import React from 'react'

import TextInput, { type Props } from './TextInput'
import EyeIcon from '../../../assets/icons/eye.svg?react'
import EyeClosedIcon from '../../../assets/icons/eye-closed.svg?react'

const PasswordInput: React.FC<Props> = (props) => {
  const [showPassword, setShowPassword] = React.useState(false)
  const togglePasswordVisibility = () => { setShowPassword(!showPassword) }

  return (
    <div className='relative'>
      <TextInput
        type={showPassword ? 'text' : 'password'}
        className='w-full border border-gray-600'
        {...props}
      />
      <button
        type='button'
        onClick={togglePasswordVisibility}
        className='absolute right-4 top-4 text-gray-500 hover:text-gray-700 focus:outline-none'
      >
        {showPassword ? <EyeClosedIcon width={20} height={20} /> : <EyeIcon width={20} height={20} />}
      </button>
    </div>
  )
}

export default PasswordInput
